import { PageHero } from "@/components/common";
import { ShieldCheck, Scale, FileText, Bot } from "lucide-react";

const PRINCIPLES = [
  "Independencia de partidos políticos, candidatos y entidades gubernamentales.",
  "Mismo estándar de fiscalización para todas las ideologías y organizaciones.",
  "Evidencia antes que acusaciones.",
  "Diferenciación visible entre hechos, análisis, opinión, propuestas y participación de usuarios.",
  "Derecho a respuesta y política pública de correcciones.",
  "Protección de datos, seguridad y moderación responsable.",
  "Transparencia sobre financiamiento, metodología y uso de inteligencia artificial.",
];

const POLICIES = [
  "Política de privacidad", "Términos de uso", "Política editorial", "Política de correcciones",
  "Derecho a réplica", "Política de fuentes", "Moderación", "Metodología de consultas",
  "Conflictos de interés", "Financiamiento", "Uso de inteligencia artificial", "Cookies y consentimiento",
];

export default function About() {
  return (
    <div data-testid="about-page">
      <PageHero label="Sobre 2Voto" title="Infraestructura cívica independiente"
        subtitle="2Voto ofrece herramientas independientes para entender, fiscalizar, evaluar y participar en las decisiones públicas mediante evidencia, tecnología y colaboración ciudadana." />
      <div className="max-w-4xl mx-auto px-6 py-12 space-y-12">
        <section className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-white rounded-lg border border-slate-200 p-6">
            <ShieldCheck className="w-6 h-6 text-cyan-500 mb-3" />
            <h3 className="font-heading font-bold text-xl text-slate-900 mb-2">Visión</h3>
            <p className="text-slate-600 text-sm leading-relaxed">Ser la principal infraestructura cívica digital en español para que la ciudadanía continúe ejerciendo su poder después de las elecciones.</p>
          </div>
          <div className="bg-white rounded-lg border border-slate-200 p-6">
            <Scale className="w-6 h-6 text-cyan-500 mb-3" />
            <h3 className="font-heading font-bold text-xl text-slate-900 mb-2">Misión</h3>
            <p className="text-slate-600 text-sm leading-relaxed">Entender, fiscalizar, evaluar y participar en decisiones públicas con transparencia, aplicando el mismo estándar a todas las ideologías.</p>
          </div>
        </section>

        <section>
          <h3 className="font-heading font-black text-2xl text-slate-900 mb-6">Principios no negociables</h3>
          <ul className="space-y-3">
            {PRINCIPLES.map((p, i) => (
              <li key={p} className="flex gap-3 text-slate-700"><span className="w-6 h-6 rounded-full bg-cyan-100 text-cyan-700 text-xs font-bold flex items-center justify-center shrink-0 mt-0.5">{i + 1}</span>{p}</li>
            ))}
          </ul>
        </section>

        <section className="bg-slate-100 rounded-lg p-6 flex gap-4">
          <Bot className="w-6 h-6 text-slate-500 shrink-0" />
          <div>
            <h3 className="font-heading font-bold text-lg text-slate-900 mb-2">Uso responsable de inteligencia artificial</h3>
            <p className="text-slate-600 text-sm leading-relaxed">La IA asiste al equipo (OCR, transcripción, resúmenes internos, extracción de datos), pero nunca reemplaza el criterio editorial ni publica conclusiones automáticamente. Toda salida que llega al público es revisada y aprobada por una persona autorizada, y queda registrada.</p>
          </div>
        </section>

        <section>
          <h3 className="font-heading font-black text-2xl text-slate-900 mb-4">Documentos y políticas</h3>
          <div className="flex flex-wrap gap-2">
            {POLICIES.map((p) => (
              <span key={p} className="inline-flex items-center gap-1.5 bg-white border border-slate-200 text-slate-600 text-sm px-3 py-1.5 rounded-full"><FileText className="w-3.5 h-3.5" /> {p}</span>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}
